










































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator'
import CircledTitle from '@/components/CircledTitle.vue'
import { Slide } from '@/@types/Slide'
import Template from '../../mixins/Template.vue'

@Component({
  name: 'introduction',
  components: {
    CircledTitle
  }
})
export default class Introduction extends Mixins<Template>(Template) {}
